export const ADD_TO_CART = 'ADD_TO_CART'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const SET_CART = 'SET_CART'
export const SUCCESS_PAYMENT = 'SUCCESS_PAYMENT'